import { render, staticRenderFns } from "./MatchingPMReadPopup.vue?vue&type=template&id=7c22eff5&scoped=true"
import script from "./MatchingPMReadPopup.vue?vue&type=script&lang=js"
export * from "./MatchingPMReadPopup.vue?vue&type=script&lang=js"
import style0 from "./MatchingPMReadPopup.vue?vue&type=style&index=0&id=7c22eff5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22eff5",
  null
  
)

export default component.exports